module.exports = __webpack_public_path__ + "static/assets/8ebc5b2d84dd8ba2ceae43c4bbc9963a.png";